import theme from '../../../lib/theme';
import { getContrastText } from '../../../lib/colourUtilities';
import { CampaignBannerProps } from './CampaignBanner';

const { colors, scale, media, corners, font } = theme;

export default ({ backgroundColor }: CampaignBannerProps) => {
  // Fall back to a neutral surface when no colour is supplied.
  const bg = backgroundColor || colors.light_grey;
  // Auto-contrast text against the background, and give the CTA the inverse
  // (button fill = text colour, label = background-ish) so it always reads.
  const textColor = getContrastText(bg) || colors.black;
  const ctaBg = textColor;
  const ctaColor = getContrastText(ctaBg) || bg;

  return {
    wrapper: {
      width: '100%',
      padding: `0 ${scale.xs}`,

      [media.m.up]: {
        padding: 0,
      },
    },

    banner: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: scale.xs,
      width: '100%',
      boxSizing: 'border-box',
      backgroundColor: bg,
      color: textColor,
      borderRadius: corners.l,
      padding: scale.s,
      fontFamily: font.families.primary,

      [media.m.up]: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: scale.m,
        padding: `${scale.s} ${scale.m}`,
      },
    },

    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: scale.xxxs,
      minWidth: 0,
    },

    kicker: {
      fontSize: font.xs,
      fontWeight: font.bold,
      lineHeight: font.heights.xs,
      textTransform: 'uppercase',
      letterSpacing: '0.08em',
      opacity: 0.8,
      color: textColor,
    },

    title: {
      fontSize: font.xl,
      fontWeight: font.bold,
      lineHeight: font.heights.xl,
      color: textColor,

      [media.m.up]: {
        fontSize: font.xxl,
        lineHeight: font.heights.xxl,
      },
    },

    subtitle: {
      fontSize: font.m,
      lineHeight: font.heights.m,
      opacity: 0.9,
      color: textColor,
      maxWidth: 640,
    },

    cta: {
      flexShrink: 0,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      whiteSpace: 'nowrap',
      backgroundColor: ctaBg,
      color: ctaColor,
      fontSize: font.m,
      fontWeight: font.bold,
      lineHeight: 1,
      textDecoration: 'none',
      padding: `${scale.xs} ${scale.s}`,
      borderRadius: corners.m,
      transition: 'opacity 0.2s ease',
      cursor: 'pointer',

      '&:hover': {
        opacity: 0.85,
      },
    },
  };
};
